import wacInput from './saveInputs/wacInput';

export default (wac) => `
    saveWAC (wac: {
        ${wacInput(wac)}
    }) {
        id
    }
`;
